import type { CountryCode, E164Number } from 'libphonenumber-js';
import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';

export const normalizePhoneNumber = (phoneNumber: string, countryCode?: CountryCode): E164Number | null => {
  if (isValidPhoneNumber(phoneNumber)) {
    return parsePhoneNumber(phoneNumber, countryCode).number;
  }
  return null;
};
